module.exports = __webpack_public_path__ + "static/media/Crystal Martin Headshot.23d98135.png";